import { ValueSetterParams } from 'ag-grid-community';
import { PxdAgGridCheckboxRendererReadOnly } from '@app/shared/aggrid/pxd-ag-grid-cell-renderers';
import { PxdAgGridColumnTypes, PxdAgGridDefaultColumnDef, PxdAgGridOptions, PxdAgGridSideBarOptions, PxdAgGridStatusBarOptions } from '@app/shared/aggrid/pxd-ag-grid-options';

export const assetMappingMultiWellAvailablesGridOptions: PxdAgGridOptions = {
  enableCharts: true,
  cellSelection: true,
  rowGroupPanelShow: 'never',
  suppressExcelExport: true,
  suppressCsvExport: true,
  defaultColDef: PxdAgGridDefaultColumnDef,
  statusBar: PxdAgGridStatusBarOptions,
  sideBar: PxdAgGridSideBarOptions,
  columnTypes: PxdAgGridColumnTypes,
  rowSelection: { mode: 'multiRow', headerCheckbox: true, selectAll: 'filtered' },
  getRowClass: params => {
    return params.data.IsActive === false ? 'highlight-row' : '';
  },
  columnDefs: [
    {
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      width: 40
    },
    { field: 'AssetId', type: ['numberColumn'], hide: true, width: 100 },
    { field: 'AssetType', type: ['textColumn'], hide: true, width: 100 },
    { field: 'Ssn', type: ['textColumn'], width: 100 },
    { field: 'AssetName', type: ['textColumn'], width: 200 },
    { field: 'Operator', type: ['textColumn'], width: 100 },
    { field: 'ActualDrillGroupReference', headerName: 'Drill Group ID', type: ['numberColumn'], width: 120 },
    { field: 'PPID', type: ['textColumn'], width: 100 },
    { field: 'PadRigReleaseDate', headerName: 'Pad RR', type: ['dateColumn'], width: 100 },
    { field: 'PadPutOnProductionDate', headerName: 'Pad POP', type: ['dateColumn'], width: 100 },
    { field: 'OWID', type: ['numberColumn'], width: 100 }
  ]
};

export const assetMappingMultiWellMappedGridOptions: PxdAgGridOptions = {
  enableCharts: true,
  cellSelection: true,
  suppressExcelExport: true,
  suppressCsvExport: true,
  rowGroupPanelShow: 'never',
  defaultColDef: PxdAgGridDefaultColumnDef,
  statusBar: PxdAgGridStatusBarOptions,
  sideBar: PxdAgGridSideBarOptions,
  columnTypes: PxdAgGridColumnTypes,
  rowSelection: { mode: 'multiRow' },
  getRowClass: params => {
    return params.data.IsActive === false ? 'highlight-row' : '';
  },
  columnDefs: [
    { field: 'Ssn', type: ['textColumn'] },
    { field: 'AssetName', type: ['textColumn'], headerName: 'Well Name' },
    { field: 'AssetType', type: ['textColumn'] },
    { field: 'Operator', type: ['textColumn'], width: 100 },
    { field: 'ActualDrillGroupReference', headerName: 'Drill Group ID', type: ['numberColumn'], width: 120 },
    { field: 'TargetFormation' },
    { field: 'TankBattery' },
    { field: 'OWID', type: ['numberColumn'] },
    { field: 'CostCenterNumber', headerName: 'Cost Center Number' },
    { field: 'CostCenter', headerName: 'Cost Center Name' },
    { field: 'County' },
    {
      field: 'IsInsideCityLimits',
      headerName: 'Inside City Limits',
      cellRenderer: PxdAgGridCheckboxRendererReadOnly
    },
    { field: 'WellWorkingInterest' },
    {
      field: 'PercentAllocation',
      editable: true,
      type: ['numberColumn'],
      valueSetter: (params: ValueSetterParams) => {
        var newValInt = Number(params.newValue);
        var valueChanged = params.oldValue !== newValInt;
        if (valueChanged) {
          params.data.PercentAllocation = newValInt != null ? newValInt : params.oldValue;
        }
        return valueChanged;
      },
      valueFormatter: params => params.value.toLocaleString('en-US', { style: 'percent', maximumFractionDigits: 6, minimumFractionDigits: 0 })
    },
    { field: 'AssetId', type: ['numberColumn'] }
  ]
};

export const assetMappingMultiWellMappedTankBatteryGridOptions: PxdAgGridOptions = {
  enableCharts: true,
  cellSelection: true,
  rowGroupPanelShow: 'never',
  suppressExcelExport: true,
  suppressCsvExport: true,
  defaultColDef: PxdAgGridDefaultColumnDef,
  statusBar: PxdAgGridStatusBarOptions,
  sideBar: PxdAgGridSideBarOptions,
  columnTypes: PxdAgGridColumnTypes,
  rowSelection: { mode: 'multiRow' },
  getRowClass: params => {
    return params.data.IsActive === false ? 'highlight-row' : '';
  },
  columnDefs: [
    { field: 'Ssn', type: ['textColumn'] },
    { field: 'AssetName', type: ['textColumn'], headerName: 'Well Name' },
    { field: 'AssetType', type: ['textColumn'] },
    { field: 'Operator', type: ['textColumn'], width: 100 },
    { field: 'ActualDrillGroupReference', headerName: 'Drill Group ID', type: ['numberColumn'], width: 120 },
    { field: 'TargetFormation' },
    { field: 'TankBattery' },
    { field: 'OWID', type: ['numberColumn'] },
    { field: 'CostCenterNumber', headerName: 'Cost Center Number' },
    { field: 'CostCenter', headerName: 'Cost Center Name' },
    { field: 'County' },
    {
      field: 'IsInsideCityLimits',
      headerName: 'Inside City Limits',
      cellRenderer: PxdAgGridCheckboxRendererReadOnly
    },
    { field: 'WellWorkingInterest' },
    {
      field: 'PercentAllocation',
      editable: true,
      type: ['numberColumn'],
      valueSetter: (params: ValueSetterParams) => {
        var newValInt = Number(params.newValue);
        var valueChanged = params.oldValue !== newValInt;
        if (valueChanged) {
          params.data.PercentAllocation = newValInt != null ? newValInt : params.oldValue;
        }
        return valueChanged;
      },
      valueFormatter: params => params.value.toLocaleString('en-US', { style: 'percent', maximumFractionDigits: 6, minimumFractionDigits: 0 })
    },
    { field: 'AssetId', type: ['numberColumn'] }
  ]
};